import '../../index.css';

const Stats = () => {
  return (
    <section className=" mb-[10rem] lg:h-[50vh] mt-[10rem]">
      <div className="text-center m-10 text-4xl lg:text-6xl space-y-6 mb-[7rem] pacifico-regular">
        <h1>We offer more than convenience.</h1>
        <p className="mt-8 font-semibold">We deliver peace of mind.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center mx-5 ">
        <div className="border-4 border-green-600 mb-5 p-2">
          <h3 className="lg:text-4xl text-2xl font-semi-bold text-green-600">
            95%
          </h3>
          <p className="text-gray-600 text-lg lg:text-2xl">
            Customer Satisfaction
          </p>
        </div>
        <div className="border-4 border-green-600 mb-5 p-2">
          <h3 className="lg:text-4xl text-2xl font-semi-bold text-green-600">
            24/7
          </h3>
          <p className="text-gray-600 text-lg lg:text-2xl">Support Available</p>
        </div>
        <div className="border-4 border-green-600 mb-5 p-2">
          <h3 className="lg:text-4xl text-2xl font-semi-bold text-green-600">
            10,000+
          </h3>
          <p className="text-gray-600 text-lg lg:text-2xl">
            Medicines Delivered
          </p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
